import styled from '@emotion/styled';
import { semantic_colors, text_styles } from '../../foundation';

export const Footer = {
  Container: styled.footer`
    display: block;
    text-align: center;
    margin: 0 auto;
    padding: 24px 0px 32px;
    ${text_styles.Caption_11_Regular};
    color: ${semantic_colors.content.secondary};
    background-color: ${semantic_colors.background.base};
  `,
  List: styled.ul`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    row-gap: 8px;
    font-style: normal;
    margin: 0;
    padding: 0;
    li {
      display: inline-block;
      &:not(:last-of-type):after {
        content: '|';
        display: inline-block;
        margin: 0 8px;
        color: ${semantic_colors.border.primary};
      }
    }
  `,
  Address: styled.address`
    margin: 0 0 8px;
    ${text_styles.Body_12_Regular};
  `,
  Link: styled.a<{ strong?: boolean }>`
    cursor: pointer;
    text-decoration: none;

    ${({ strong }) => (strong ? text_styles.Caption_11_SemiBold : text_styles.Caption_11_Regular)};
    color: ${({ strong }) => (strong ? semantic_colors.content.primary : semantic_colors.content.secondary)};
    &:hover {
      text-decoration: underline;
    }
  `,
};
